// extracted by mini-css-extract-plugin
module.exports = {"buttonBorderless":"IconButton_buttonBorderless__9dEku","button":"IconButton_button__29vBa","disabled":"IconButton_disabled__KmwV1","alternate":"IconButton_alternate__2UPpH"};